import React, { useState, useCallback } from 'react'
import {useDropzone} from 'react-dropzone'
import Header from './components/Header'
import Main from './components/Main'
import Footer from './components/Footer'
import FileSaver from 'file-saver'
import './App.css'
import { useStickyState } from './util/hooks'
import { motion, AnimatePresence } from "framer-motion"

function App() {

  const [ images, setImages ] = useStickyState([])
  const [ inputImageURL, setInputImageURL ] = useState("")

  // Drag and Drop Handlers ==========================================

  const onDrop = useCallback(acceptedFiles => {

    const reader = new FileReader()
    reader.addEventListener('load', () => {
        const newImages = JSON.parse(reader.result)
        setImages(newImages)
    })
    reader.readAsText(acceptedFiles[0])

  }, [setImages])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop, noClick: true})

  // Form Handlers =================================================

  function changeHandler(e) {
    setInputImageURL(e.target.value)
  }

  function submitHandler(e) {
    e.preventDefault()
    if (!inputImageURL) {
      return
    }
    setImages(prev => {
      let newImage = {
        url: inputImageURL,
        id: Date.now()
      }
      const newImages = prev.concat(newImage)
      return newImages
    })
    setInputImageURL("")
  }

  // Image Handlers =================================================

  function removeHandler(e, id) {
    e.preventDefault()
    setImages(prev => {
      const array = [...prev]
      const index = array.findIndex(item => item.id === id)
      array.splice(index, 1);
      return array
    })
  }

  // Header Handlers =================================================

  function resetHandler(e) {
    e.preventDefault()
    setImages([])
  }

  function uploadHandler(e) {
    e.preventDefault()

    function uploadText() {
        return new Promise((resolve) => {
            // create file input
            const uploader = document.createElement('input')
            uploader.type = 'file'
            uploader.style.display = 'none'

            // listen for files
            uploader.addEventListener('change', () => {
                const files = uploader.files

                if (files.length) {
                    const reader = new FileReader()
                    reader.addEventListener('load', () => {
                        uploader.parentNode.removeChild(uploader)
                        resolve(reader.result)
                    })
                    reader.readAsText(files[0])
                }
            })

            // trigger input
            document.body.appendChild(uploader)
            uploader.click()
        })
    }

    uploadText().then(upload => {
      const newImages = JSON.parse(upload)
      setImages(newImages)
    })
  }

  function saveHandler(e) {
    e.preventDefault()

    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(images));
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href",     dataStr);
    downloadAnchorNode.setAttribute("download", "savedBoard.json");
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  function downloadHandler(e) {
    e.preventDefault()

    images.forEach(img => {
      FileSaver.saveAs(`${img.url}`, `${img.id}.jpg`);
    });
  }


  // Return =================================================

  return (
    <div className="app" {...getRootProps()}>
      <input {...getInputProps()} />
      <AnimatePresence>
        { isDragActive ? (
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className='dnd-upload'
              >
                <h2>Upload File...</h2>
              </motion.div>
            ) : null
          }
      </AnimatePresence>
      <Header
        resetHandler={resetHandler}
        saveHandler={saveHandler}
        uploadHandler={uploadHandler}
        downloadHandler={downloadHandler}
      />
      <Main
        images={images}
        setImages={setImages}
        changeHandler={changeHandler}
        submitHandler={submitHandler}
        inputImageURL={inputImageURL}
        removeHandler={removeHandler}
      />
      <Footer />
    </div>
  );
}

export default App
